export default __webpack_public_path__ + "static/media/teilor-logo.8594c915.svg";